import { get } from 'lodash';
import { bool, func, object, string } from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';

const DisplayFieldOption = ({ disabled, item, keySetter, onChange, label }) => {
  const handleChange = (e) => {
    e.preventDefault();

    onChange({
      id: item.id,
      settingKey: keySetter,
      value: e.target.checked,
    });
  };

  return (
    <Wrapper>
      <InputTitle id={item.id} label={label} position="left" />
      <CheckboxInput
        disabled={disabled}
        id={item.id}
        name={item.id}
        onChange={handleChange}
        value={get(item, keySetter)}
        width="auto"
      />
    </Wrapper>
  );
};

export const DisplayFieldOptionInFieldList = ({
  fieldSetting,
  fieldSettingPath,
  index,
  item,
  onChange,
}) => {
  const { label, identifier } = fieldSetting;

  const fieldLabel = __('Display %{label}').i__({ label });
  const isFirst = index === 0;

  return (
    <Box flexDirection="column">
      {!isFirst && <Divider m={0} />}
      <Box mt={isFirst ? 2 : 4}>
        <DisplayFieldOption
          item={item}
          keySetter={`${fieldSettingPath}.${identifier}`}
          label={fieldLabel}
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};

export default DisplayFieldOption;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
  width: '100%',
}))``;

DisplayFieldOption.defaultProps = {
  disabled: false,
  label: __('Display'),
};

DisplayFieldOption.propTypes = {
  disabled: bool,
  item: object.isRequired,
  keySetter: string.isRequired,
  onChange: func.isRequired,
  label: string,
};
